import { Plugin } from 'chart.js';

interface EndValuePluginOptions {
  color?: string;
  font?: string;
  offsetX?: number;
  textAlign?: CanvasTextAlign;
  formatter?: (value: number) => string;
}

export const createEndValuePlugin = (pluginOptions: EndValuePluginOptions = {}): Plugin<'bar'> => {
  const {
    color = '#7b7b7b',
    font = 'normal 11px sans-serif',
    offsetX = 6,
    textAlign = 'start',
    formatter = String,
  } = pluginOptions;

  return {
    id: 'endValuePlugin',
    afterDatasetsDraw(chart) {
      const { ctx } = chart;
      chart.data.datasets.forEach((dataset, datasetIndex) => {
        const meta = chart.getDatasetMeta(datasetIndex);
        meta.data.forEach((bar, index) => {
          const value = dataset.data[index] as number;
          const { x, y } = bar.getProps(['x', 'y'], true) as { x: number; y: number };
          ctx.save();
          ctx.fillStyle = color;
          ctx.font = font;
          ctx.textAlign = textAlign;
          ctx.textBaseline = 'middle';
          ctx.fillText(formatter(value), x + offsetX, y);
          ctx.restore();
        });
      });
    },
  };
};

export const endValuePlugin = createEndValuePlugin();
